import { render, staticRenderFns } from "./evidencias.vue?vue&type=template&id=e8cf43a0&scoped=true&"
import script from "./evidencias.vue?vue&type=script&lang=js&"
export * from "./evidencias.vue?vue&type=script&lang=js&"
import style0 from "./evidencias.vue?vue&type=style&index=0&id=e8cf43a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8cf43a0",
  null
  
)

export default component.exports